import type { RidePoint, RideProgress } from './ride';

export interface RideSegment {
  readonly points: readonly RidePoint[];
  readonly startIndex: number;
}

/** Splits disconnected geometry while preserving original point indexes. */
export function splitRideSegments(points: readonly RidePoint[]): RideSegment[] {
  const starts = points.flatMap((point, index) => index === 0 || point.segmentStart ? [index] : []);
  return starts.map((startIndex, index) => ({
    startIndex, points: points.slice(startIndex, starts[index + 1] ?? points.length),
  }));
}

/** Maps global playback to an individual segment's reveal state. */
export function segmentProgress(segment: RideSegment, progress: RideProgress): RideProgress {
  const { points, startIndex } = segment;
  if (progress.pointIndex < startIndex) return {
    fraction: 0, pointIndex: 0, currentPoint: points[0]!, traveledPoints: [points[0]!, points[0]!],
  };
  if (progress.pointIndex >= startIndex + points.length - 1 || progress.fraction === 1) return {
    fraction: 1, pointIndex: points.length - 2, currentPoint: points.at(-1)!, traveledPoints: points,
  };
  return { fraction: progress.fraction, currentPoint: progress.currentPoint,
    pointIndex: progress.pointIndex - startIndex,
    get traveledPoints() { return progress.traveledPoints.slice(startIndex); } };
}
